// extracted by mini-css-extract-plugin
export var chevronIcon = "_74-2";
export var teamName = "_74-1";
export var teamSwitcherButton = "_74-0";